import { HelpCenterProvider } from '@/HelpCenter/ui/context'
import { createHelpCenterRepository } from '@/HelpCenter/infrastructure/ApiHelpCenterRepository'
import { TicketDetailContainer } from '../organisms'

export const TicketDetailPage = (): JSX.Element => {
    return (
        <HelpCenterProvider repository={createHelpCenterRepository()}>
            <div className="page-wrapper" style={{ paddingTop: '12px', minHeight: '100vh', paddingBottom: '12px' }}>
                <TicketDetailContainer />
            </div>
        </HelpCenterProvider>
    )
}
